import InstanceSpecificPanel from '../instance_specific_panel/instance_specific_panel.vue'
import FeaturesPanel from '../features_panel/features_panel.vue'
import TermsOfServicePanel from '../terms_of_service_panel/terms_of_service_panel.vue'
import StaffPanel from '../staff_panel/staff_panel.vue'
import MRFTransparencyPanel from '../mrf_transparency_panel/mrf_transparency_panel.vue'
import LocalBubblePanel from '../local_bubble_panel/local_bubble_panel.vue'

const About = {
  components: {
    InstanceSpecificPanel,
    FeaturesPanel,
    TermsOfServicePanel,
    StaffPanel,
    MRFTransparencyPanel,
    LocalBubblePanel
  },
  computed: {
    currentUser () { return this.$store.state.users.currentUser },
    showFeaturesPanel () { return this.$store.state.instance.showFeaturesPanel },
    showLocalBubblePanel () {
      return this.$store.state.instance.localBubbleInstances.length > 0
    }
  }
}

export default About
